import { FC } from 'react'
import { useBuCompanySettingsReviewerRelations } from '../../../graphql/companySettings/useCompanySettingsReviewer'
import { NewLoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors/NewLoadingAndErrors'
import BackgroundBox from '../../../components/custom_components/BackgroundBox'
import { useTranslation } from 'react-i18next'
import { BuReviewerTable } from './BuReviewerTable'
import { BuReviewerInfoBox } from './BuReviewerInfoBox'

export const CompanySettingsBuReviewerTab: FC<{ businessUnitId: string; buName: string; companyId: string }> = ({
  businessUnitId,
  buName,
  companyId,
}: {
  businessUnitId: string
  buName: string
  companyId: string
}) => {
  const { t } = useTranslation()

  const { loading, data, error } = useBuCompanySettingsReviewerRelations(businessUnitId)

  const hasNoData = !data || !data.reviewersRelationOfBusinessUnitId || !data.activeSubordinatesOfBuManager

  const isLoadingOrError = loading || error || hasNoData

  if (isLoadingOrError) {
    return (
      <BackgroundBox r height="withTabs">
        <NewLoadingAndErrors isLoading={loading} hasNoData={hasNoData} error={error} showSpinner t={t} />
      </BackgroundBox>
    )
  } else {
    return (
      <>
        <BuReviewerInfoBox
          existingRelations={data!.reviewersRelationOfBusinessUnitId}
          subordinates={data!.activeSubordinatesOfBuManager}
          buId={businessUnitId}
          companyId={companyId}
          buName={buName}
        />
        <BuReviewerTable tableData={data!.reviewersRelationOfBusinessUnitId} buId={businessUnitId} />
      </>
    )
  }
}
